import React from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const Settings = {
  Name: 'Welcome',
  Display: true,
};

const View = () => (
  <Box>
    <Typography variant="body2" color="text.secondary" component="p">
      Welcome to this device.
    </Typography>
    <NavLink to="/documents/widgets">Read about widgets</NavLink>
  </Box>
);

export default {
  Settings,
  View,
};
